import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import contactus from "../../assets/contactus.png";
import mail from "../../assets/mail.svg";
import { Helmet } from 'react-helmet';   ///this used for changing the title of the page
import Swal from 'sweetalert2';

import "./contact.css";
import BASE_URL from "../../config.js";
const Contact = () => {
  const navigate = useNavigate();

  //let us talk form code begin

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [service, setService] = useState('');
  const [message, setMessage] = useState('');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [serviceError, setServiceError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [messageSuccess, setMessageSuccess] = useState('');

  const services = [
    { value: 'branding analysis', label: 'Branding Analysis' },
    { value: 'graphic-designer', label: 'Graphic Designer' },
    { value: 'digital-marketing', label: 'Digital Marketing' },
    { value: 'new business packages', label: 'New Business Packages' },
    { value: 'web development', label: 'Web Development' },
    { value: 'app development', label: 'App Development' },
  ];

  const handleSelect = (event) => {
    setService(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Clear previous errors
    setNameError('');
    setEmailError('');
    setPhoneError('');
    setServiceError('');
    setMessageError('');
    setMessageSuccess('');

    // Validation checks
    if (!name.trim()) {
      setNameError('Please enter your name.');
      return;
    }

    if (!email.trim()) {
      setEmailError('Please enter your email.');
      return;
    }

    // Email validation using regular expression
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Please enter a valid email address.');
      return;
    }

    if (!phone.trim()) {
      setPhoneError('Please enter your phone number.');
      return;
    }

    // Phone number validation using regular expression
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      setPhoneError('Please enter a valid 10-digit phone number.');
      return;
    }

    if (!service) {
      setServiceError('Please select a service.');
      return;
    }

    if (!message.trim()) {
      setMessageError('Please enter your message.');
      return;
    }

    // If all validations pass, proceed with form submission
    const data = { name, email, phone, service, message };
    
    // Show loading state
    Swal.fire({
      title: 'Sending...',
      text: 'Please wait while we process your request.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await fetch(`${BASE_URL}/api/contact-form.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      const result = await response.json();
      console.log('Form submission result:', result);

      if (result.status === 'success') {
        // Redirect to Thank You page
        navigate('/thank-you');
        
        // Clear form
        setName('');
        setEmail('');
        setPhone('');
        setService('');
        setMessage('');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: result.message || 'Something went wrong. Please try again later.',
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error.message);
      Swal.fire({
        icon: 'error',
        title: 'Submission Failed',
        text: 'Could not connect to the server. Please check your internet connection and try again.',
      });
    }
  };
  //letus talk form code end

  return (


    <>

      <Helmet>
        <title>Contact Us  | Vasmi Group</title>
      </Helmet>


      <div className="contactus-main">
        <img src={contactus} alt="contact" className="contact-land" />
        <div className="contact-details">
          <p className="contact-address">Address:</p>
          <p className="contact-address-para">#39-14-6/5 <br />
            Madhavadara-Muralinagar Jn.<br />
            Beside ICICI Bank <br />
            Visakhapatnam - 530007</p>
        </div>
        {/* <div className="head-of-company">
        <div className="saikrishna">
          <p className="sainame">SaiKrishna</p>
          <p className="designation">CEO</p>
        </div>
        <div className="niranjan">
          <p className="sainame">Niranjan</p>
          <p className="designation">MD</p>
        </div>
      </div> */}
        <div className="home-form">
          <div className="left-form-sec">
            <p className="home-left-form">SO What Next</p>
            <p className="lets-work-form">Let’s Work</p>
            <p className="not-sure-form">Not Sure Where To start?</p>
            <form method="post" className="form-hom" onSubmit={handleSubmit}>
              <div className="inp-error">

                <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
                {nameError && <p className="error">{nameError}</p>}
              </div>
              <div className="inp-error">

                <input type="text" placeholder="PhoneNumber" value={phone} onChange={(e) => setPhone(e.target.value)} />
                {phoneError && <p className="error">{phoneError}</p>}
              </div>
              <div className="inp-error">

                <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                {emailError && <p className="error">{emailError}</p>}
              </div>
              <div className="inp-error">

                <select name="services" placeholder="Services Interested In" id="services" onChange={handleSelect}>
                  <option value="">-- Select Service --</option> {/* Default option */}
                  {services.map((serviceOption) => (
                    <option key={serviceOption.value} value={serviceOption.value}>
                      {serviceOption.label}
                    </option>
                  ))}
                </select>
                {serviceError && <p className="error">{serviceError}</p>}
              </div>
              <div className="inp-error">

                <textarea name="Message" id="#" cols="30" rows="10" placeholder="Message" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                {messageError && <p className="error">{messageError}</p>}
              </div>
              <div className="successmeet">

                <button>Submit</button>
                {messageSuccess && <p className="success">{messageSuccess}</p>}
              </div>


            </form>
          </div>
          <div className="right-form-sec">
            <p className="left-work-form">Let’s Talk</p>
            <p className="call-form-home">+91 95507 64936</p>

            <p className="mail-form-home">
              {" "}
              <img src={mail} alt="mail" /> info@vasmigroup.com
            </p>
          </div>
        </div>
      </div>
    </>


  );
};

export default Contact;
